<div class="flex gap-1 items-center" [class.opacity-50]="readOnly()">
  <!-- No Rating (-1) -->
  <button
    type="button"
    class="p-0 border-0 bg-transparent transition-colors"
    [disabled]="readOnly()"
    (click)="select(-1)"
    pTooltip="No Rating"
    [ngClass]="{
      'cursor-pointer hover:text-gray-600': !readOnly(),
      'text-red-500': value() === -1,
      'text-gray-400': value() !== -1,
    }"
  >
    <i class="pi pi-ban text-lg" aria-hidden="true"></i>
    <span class="sr-only">No Rating</span>
  </button>

  <!-- Not Seen (0) -->
  <button
    type="button"
    class="p-0 border-0 bg-transparent ml-1 transition-colors"
    [disabled]="readOnly()"
    (click)="select(0)"
    pTooltip="Not Seen"
    [ngClass]="{
      'cursor-pointer hover:text-gray-600': !readOnly(),
      'text-red-500': value() === 0,
      'text-gray-400': value() !== 0,
    }"
  >
    <i class="pi pi-eye-slash text-lg" aria-hidden="true"></i>
    <span class="sr-only">Not Seen</span>
  </button>

  <!-- Stars (1-4) -->
  <div class="flex ml-2">
    @for (star of stars; track star) {
      <button
        type="button"
        class="p-0 border-0 bg-transparent mr-0.5 transition-transform transition-colors"
        [disabled]="readOnly()"
        (click)="select(star)"
        (mouseenter)="hoveredStar.set(star)"
        (mouseleave)="hoveredStar.set(null)"
        [ngClass]="{
          'cursor-pointer hover:scale-110': !readOnly(),
          'text-red-500': isStarSelected(star),
          'text-gray-300': !isStarSelected(star),
        }"
      >
        <i
          class="pi text-lg"
          [ngClass]="{
            'pi-star-fill': isStarSelected(star),
            'pi-star': !isStarSelected(star),
          }"
          aria-hidden="true"
        ></i>
        <span class="sr-only">{{ star }} star</span>
      </button>
    }
  </div>
</div>
